import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb } from "@progress/kendo-react-layout";
import { getPath, getPathById } from "../utils/helper";
import withMeta from '../../coraWebComponents/utils/withMeta';
import "./Breadcrumb.scss";

const BreadcrumbComponent = (props) => {
  const [path, setPath] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  const onItemSelect = (e) => {
    const item = path.find(x => x.MenuID.toString() === e.id);
    if (item.Route) {
      navigate(item.Route)
    }
    else {
      navigate("./menu", { state: { id: item.MenuID } })
    }
  }

  useEffect(() => {
    const menu = props.meta.menuTree;

    if (location.pathname === "/menu" && location.state?.id) {
      let newPath = getPathById(location.state?.id, menu);
      newPath.shift();
      setPath(newPath);
    }
    else {
      let newPath = getPath(location.pathname, menu);
      newPath.shift();
      setPath(newPath);
    }
  }, [props.meta.menuTree, location]);

  return (
    <Breadcrumb
      className="breadcrumb"
      data={path}
      textField="Title"
      onItemSelect={onItemSelect}
      valueField={"MenuID"}
    />
  );
};

export default withMeta(BreadcrumbComponent);